import videojs from "video.js";

const Component = videojs.getComponent("Component");

/**
 * While still loading, the player **may** set a null source (effectively
 * preventing video playback). This tends to throw errors about "no valid
 * source handler found". So here's a valid source handler.
 */
class NullSourceHandler extends Component
{
	/**
	 * @constructor for compatibility with existing source handlers
	 */
	constructor()
	{
		super();
		this.name = "NullSourceHandler";
	}

	// eslint-disable-next-line class-methods-use-this
	canPlayType()
	{
		return "";
	}

	// eslint-disable-next-line class-methods-use-this
	canHandleSource(srcObj)
	{
		return !srcObj.type;
	}

	handleSource()
	{
		this.trigger("loadstart");
		return this;
	}

	// eslint-disable-next-line class-methods-use-this
	duration()
	{
		return 0;
	}

	// eslint-disable-next-line class-methods-use-this
	seekable()
	{
		return videojs.createTimeRanges();
	}

	// eslint-disable-next-line class-methods-use-this
	seeking()
	{
		return false;
	}
}

// Register the SourceHandler with the HTML5 tech
videojs.getTech("Html5").registerSourceHandler(new NullSourceHandler());
